module.exports = __webpack_public_path__ + "media/components/breakheader/static/icon--heart-red-e745b9e3937c8e999a0360ce0f69a5c7.svg";